module.exports = __webpack_public_path__ + "static/media/cards-usage.ecf9f122.svg";